function hideTarget()
{
  // document.getElementById(target).style.opacity = "0";
  document.getElementById("imageTarget").style.display = "none";
  document.getElementById("wordTarget").style.display = "none";
}

function hideTest()
{
  // document.getElementById(testContainer).style.opacity = "0";
  document.getElementById("image1").style.display = "none";
  document.getElementById("image2").style.display = "none";
  document.getElementById("image3").style.display = "none";
  document.getElementById("image4").style.display = "none";
  document.getElementById("image5").style.display = "none";
  document.getElementById("image6").style.display = "none";

  for (var i = 1; i <= window.stimFieldsMax; i++)
  {
    stimContainers[i] && (stimContainers[i].style.display = 'none');
  }
}

function hideTargetAndTest()
{
  hideTarget();
  hideTest();
}